import React, { useState } from "react";
import NxtbnDrawer from "../../drawer";
import useApi from "../../../api";
import { InputField, NXForm } from "../../common";
import { NXUser } from "../../../icons";
import { toast } from "react-toastify";
import SelectStyled from "../../Select";
import enumChoice, { getEnumItem } from "../../../enum";

interface FormProps {
  edit?: any;
  isOpen: boolean;
  onClose: () => void;
}

function CreateUserForm({ edit, isOpen, onClose }: FormProps) {
  const api = useApi();
  const initialFormData = {
    first_name: '',
    last_name: '',
    email: '',
    avatar: '',
    phone_number: '',
    is_store_admin: false,
    is_store_staff: false,
  }
  const [formData, setFormData] = useState<any>(edit ? edit : initialFormData)
  const [errorData, setErrorData] = useState<any>()
  const [avatar, setAvatar] = useState<File>()

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev:any)=>({
      ...prev,
      [name]: value
    }))
  };

  const handleSelectChange = (name:any, value:any) => {
    setFormData((prev:any)=>({
      ...prev,
      [name]: value
    }))
  }

  const handleImageUpload = (e:React.ChangeEvent<HTMLFormElement>) => {
    const { name, files } = e.target
    if (files && files.length > 0) {
      const selectedFile = files[0];
      setAvatar(selectedFile);
      setFormData((prev:any) => ({
        ...prev,
        [name]: selectedFile,
      }));
    }
  }

  const updatedFormData = {
    ...formData, 
    avatar: avatar ? avatar: null
  }


  const onSubmit = (e:any) => {
    e.preventDefault()
    if(!edit){ 
    api.createUser(formData).then((response:any)=>{
      toast.success('Successfuly created user.')
      onClose()
    }).catch((error:any)=>{
      setErrorData(error.response.data)
      toast.error('Error creating user.')
    })}else{
      api.updateUser(edit.id, updatedFormData).then((response:any)=>{
        toast.success('Successfully update user.')
        onClose()
      }).catch((error:any)=>{
        setErrorData(error.response.data)
        toast.error('Error update user.')
      })
    }
  }
    
  return (
    <NxtbnDrawer
      size="md"
      isOpen={isOpen}
      onClose={()=>{
        setFormData(null)
        onClose()
      }}
      title={edit ? "Update User" : "Add User"}
    >
      <NXForm
        className="p-4"
        onSubmit={onSubmit}
        title="User Information"
        nonFieldError={{}}
      >

          <div className="mb-6">
            <label htmlFor="avatar" className="text-sm font-medium text-gray-700 flex justify-center ">
              {formData.avatar || avatar ? 
              <img src={avatar ? URL.createObjectURL(avatar) : formData.avatar} alt="" className="h-[150px] w-[150px] aspect-square object-cover border rounded-full hover:bg-gray-300"/>:
              <NXUser className="h-[150px] w-[150px] aspect-square object-cover cursor-pointer border rounded-full hover:bg-gray-300"/>
              }
            </label>
            <InputField
              id="avatar"
              type="file"
              name="avatar"
              onChange={(e:any)=>handleImageUpload(e)}
              errorData={errorData}
              className="hidden"
            />
          </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">

          <div>
            <label className="block text-sm font-medium text-gray-700">
              First Name
            </label>
            <InputField
              type="text"
              name="first_name"
              placeholder="First Name"
              value={formData.first_name}
              onChange={handleInputChange}
              required
              className="mt-1 w-full p-2 border rounded"
              errorData={errorData}
            />
          </div>
       

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Last Name
            </label>
            <InputField
              type="text"
              name="last_name"
              placeholder="Last Name"
              value={formData.last_name}
              onChange={handleInputChange}
              required
              className="mt-1 w-full p-2 border rounded"
              errorData={errorData}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Email
            </label>
            <InputField
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleInputChange}
              required
              className="mt-1 w-full p-2 border rounded"
              errorData={errorData}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Phone Number
            </label>
            <InputField
              type="text"
              name="phone_number"
              placeholder="Phone Number"
              value={formData.phone_number}
              onChange={handleInputChange}
              required
              className="mt-1 w-full p-2 border rounded"
              errorData={errorData}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Role
            </label>
            <InputField
              type="text"
              name="Role"
              placeholder="Head of Procurement"
              value={formData.role}
              onChange={handleInputChange}
              required
              className="mt-1 w-full p-2 border rounded"
              errorData={errorData}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Password
            </label>
            <InputField
              type="password"
              name="password"
              placeholder="Password.."
              value={formData.password}
              onChange={handleInputChange}
              required
              className="mt-1 w-full p-2 border rounded"
              errorData={errorData}
            />
          </div>
        </div>

        <div className="flex items-center gap-4">
          <label className="flex items-center space-x-2">
            <input
              type="checkbox"
              name="is_store_admin"
              checked={formData.is_store_admin}
              onChange={(e) => handleSelectChange(e.target.name, e.target.checked)}
              className="h-4 w-4 text-green-600 border-gray-300 rounded focus:ring-green-500"
            />
            <span className="text-sm text-gray-700">Is Store Admin</span>
          </label>
          <label className="flex items-center space-x-2">
            <input
              type="checkbox"
              name="is_store_staff"
              checked={formData.is_store_staff}
              onChange={(e) => handleSelectChange(e.target.name, e.target.checked)}
              className="h-4 w-4 text-green-600 border-gray-300 rounded focus:ring-green-500"
            />
            <span className="text-sm text-gray-700">Is Store Staff</span>
          </label>
        </div>

       
        <div className="flex justify-end mt-4">
          <button
            type="submit"
            className="px-4 py-2 text-white bg-[#0CAF60] hover:bg-[#098d4d] disabled:bg-[#0caf609a] text-sm font-medium rounded-md shadow-sm focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            {edit ? 'Update User' : 'Create User'}
          </button>
        </div>
      </NXForm>
    </NxtbnDrawer>
  );
}

export default CreateUserForm;
